import React, { useState } from 'react';
import { faBars, faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Menu from './Menu';
import styles from './Header.module.scss';

const Header: React.FC = () => {
  const [isMenuOpened, setMenuOpened] = useState<boolean>(false);

  const openMenu = () => {
    setMenuOpened(true);
  };

  const closeMenu = () => {
    setMenuOpened(false);
  };

  const OpenMenuButton = () => (
    <button type='button' className={styles.header__button_open} onClick={openMenu}>
      <FontAwesomeIcon icon={faBars} />
    </button>
  );

  const CloseMenuButton = () => (
    <button type='button' className={styles.header__button_close} onClick={closeMenu}>
      <FontAwesomeIcon icon={faTimes} />
    </button>
  );

  return (
    <header className={styles.header}>
      <h1 className={styles.header__title}>
        <img
        src='https://contents.rals.biz/assets/common/img/rals/img_logo_rals.png'
          alt='RALSNET'
          className={styles.header__logo}
          height='20'
        />
        HP制作カタログ
      </h1>
      {isMenuOpened ? <CloseMenuButton /> : <OpenMenuButton />}
      <Menu isOpen={isMenuOpened} close={closeMenu} />
    </header>
  );
};

export default Header;
